export type Cohort = "fall_2026" | "spring_2027" | "fall_2027";

export const COHORTS: { key: Cohort; label: string; window: string; slug: string }[] = [
  { key: "fall_2026", label: "Fall 2026", window: "Default for students without a Spring/Fall '27 form answer", slug: "fall-2026" },
  { key: "spring_2027", label: "Spring 2027", window: "From enrollment form answer", slug: "spring-2027" },
  { key: "fall_2027", label: "Fall 2027", window: "From enrollment form answer", slug: "fall-2027" },
];

/** Parse a free-text enrollment-form intake answer like "Fall 2026", "spring '27", "Winter 2027". */
export function cohortFromIntakeTerm(term: string | null | undefined): Cohort | null {
  if (!term) return null;
  const t = term.toLowerCase().replace(/\s+/g, " ");
  const m = t.match(/20(2[6-9])|'?\b(2[6-9])\b/);
  const yy = m ? m[1] ?? m[2] : null;
  if (/spring|winter|jan/.test(t)) return !yy || yy === "27" ? "spring_2027" : null;
  if (/fall|autumn|aug/.test(t)) {
    if (yy === "27") return "fall_2027";
    if (yy === "26") return "fall_2026";
  }
  return null;
}

/** Legacy helper: classify by visa interview date (YYYY-MM-DD). */
export function cohortFromInterviewDate(date: string | null | undefined): Cohort | null {
  if (!date) return null;
  const d = date.slice(0, 10);
  if (d <= "2026-08-31") return "fall_2026";
  if (d <= "2027-01-31") return "spring_2027";
  if (d <= "2027-08-31") return "fall_2027";
  return null;
}

/**
 * Enrollment form answer decides Spring 2027 / Fall 2027.
 * Without a form answer, students stay in Fall 2026 (late-Sept interview
 * slots are Fall 2026 consulate delays) unless their dates are past Jan 2027.
 */
export function classifyCohort(s: {
  intake_term?: string | null;
  interview_date?: string | null;
  created_at?: string | null;
}): Cohort | null {
  const fromForm = cohortFromIntakeTerm(s.intake_term);
  if (fromForm) return fromForm;
  const d = (s.interview_date ?? s.created_at ?? "").slice(0, 10);
  if (!d || d <= "2027-01-31") return "fall_2026";
  return null;
}
